import { getEnvironmentConfig } from '~utils/environment';
import CONFIGURATIONS from './configurations';
export default function getApplicationConfig() {
    const env = getEnvironmentConfig();
    return CONFIGURATIONS[env.environmentId] || CONFIGURATIONS.local;
}
